import React from 'react';
import { PrivacyStatementContent, PRIVACY_STATEMENT_EFFECTIVE_DATE } from '../components/legal/PrivacyStatement';

export default function PrivacyPage() {
  return <main data-testid="page-privacy" className="min-h-screen bg-[#0a0a0f] p-4 text-white">
    <div className="mx-auto max-w-3xl py-6">
      <a href="/" className="text-sm text-[#92a7e8] underline">Back to MyGoal</a>
      <section className="mt-6 overflow-hidden rounded-[32px] border border-white/10 bg-[#11121b]">
        <header className="border-b border-white/10 px-6 py-5">
          <h1 className="text-2xl font-bold">Privacy Statement</h1>
          <p className="mt-2 text-sm text-white/55">MyGoal App B.V. — Effective date: {PRIVACY_STATEMENT_EFFECTIVE_DATE}</p>
        </header>
        <PrivacyStatementContent />
      </section>
    </div>
  </main>;
}
